import { useStaticQuery, graphql } from 'gatsby'

const useFaleConoscoMetadata = () => {
  const { wpMenu } = useStaticQuery(
    graphql`
      query FaleConosco1 {
        wpMenu(databaseId: { eq: 1660 }) {
          id
          menuItems {
            nodes {
              url
              label
              childItems {
                nodes {
                  id
                  url
                  label
                }
              }
            }
          }
        }
      }
    `
  )
  return wpMenu.menuItems
}
export default useFaleConoscoMetadata
